import { useEffect } from "react";
import confetti from "canvas-confetti";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import { modalVariants } from "../../../Utils/constants";

import { PersonHoldingHouseRoof } from "../../../Assets/Images";

function OptedInContent({ onClose }) {
  useEffect(() => {
    const palette = ["#ffffff", "#f0f0f0", "#54FF99", "#6EFFAA", "#3BD87A", "#e0e0e0"];

    confetti({ particleCount: 80, spread: 140, origin: { x: 0.5, y: 0.35 }, colors: palette, scalar: 1.2, gravity: 0.6, ticks: 160, startVelocity: 45, shapes: ["circle"] });
    setTimeout(() => confetti({ particleCount: 50, spread: 140, origin: { x: 0.2, y: 0.3 }, colors: palette, scalar: 1, gravity: 0.5, ticks: 140, startVelocity: 40, shapes: ["circle"] }), 150);
    setTimeout(() => confetti({ particleCount: 50, spread: 140, origin: { x: 0.8, y: 0.3 }, colors: palette, scalar: 1, gravity: 0.5, ticks: 140, startVelocity: 40, shapes: ["circle"] }), 250);
  }, []);

  return (
    <>
      <div className="modal-image opted-in mb-4">
        <img src={PersonHoldingHouseRoof} alt="" />
      </div>
      <div className="modal-dialog-content">
        <h3 className="modal-status-title mb-3">You’ve successfully enrolled in Stake Credit Builder</h3>
        <ul className="benefits-list">
          <li>You will receive a confirmation text and a confirmation email.</li>
          <li>
            We will notify you every time we report one of your on time payments to help boost your credit score.
          </li>
          <li>
            We will only report your on-time payments. If you do not pay on time, we will not report anything to the
            credit bureaus.
          </li>
        </ul>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={onClose}>Continue</PrimaryButton>
      </div>
    </>
  );
}

export default function renderOptedIn(modalContext) {
  const { updateModalComponent, setModalVariant, onModalClose, setModalClassName, setModalAriaLabel } = modalContext;

  updateModalComponent(() => <OptedInContent onClose={onModalClose} />);
  setModalVariant(modalVariants.flexDialog);
  setModalClassName("hide-header");
  setModalAriaLabel?.("Credit Builder enrolled");
}
